import React from "react";
import { Link } from "react-router-dom";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Tooltip from "@mui/material/Tooltip";
import Snackbar from "@mui/material/Snackbar";
import cn from "classnames";
import { IconButton } from "@mui/material";

export const TextItem = (props: {
    text: string;
    link?: string;
    icon?: string;
    badge?: string;
    highlighted?: boolean;
    onClick?: () => void;
    copyToClipboard?: boolean;
}) => {
    const { text, link, icon, badge, copyToClipboard } = props;
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setSnackbarOpen(true);
        } catch (e) {
            // fallback: do nothing
        }
    };

    const CopyButton = (
        <Tooltip title="Copy">
            <IconButton
                size="small"
                type="button"
                onClick={handleCopy}
                className="textItemCopyButton"
                style={{ opacity: 0, transition: "opacity 0.2s" }} // Initially hidden
            >
                <ContentCopyIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );

    const component = link ? (
        <Link
            to={"?uri=" + encodeURIComponent(link)}
            className={cn({ "text-info": props.highlighted })}
            onClick={props.onClick}
        >
            {text}
        </Link>
    ) : copyToClipboard ? (
        <div className="textItemCopyContainer">
            {text}
            {CopyButton}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={1200}
                onClose={() => setSnackbarOpen(false)}
                message="Copied!"
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            />
        </div>
    ) : (
        text
    );

    return (
        <>
            <span
                className={cn("mr-auto", {
                    "text-item-container": !copyToClipboard
                })}
            >
                {icon ? <span className={`text-item-icon ${icon}`} /> : <></>}
                {component}
            </span>
            <span className="text-item-badge badge">{badge}</span>
        </>
    );
};
